import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EmployeeConceptService {
  private apiUrl = environment.apiUrl + '/employee_concepts/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor
  
  private currentEC= new BehaviorSubject<any>(null)
  currentEC$=this.currentEC.asObservable()

  setCurrentEC$(EC:any){
    this.currentEC.next(EC)
  }

  get(employeeId?: any, periodId?: any): Observable<any> {
    let params = new HttpParams({ fromObject: {
      'employeeId': employeeId,
      'periodId': periodId
    }});

    return this.http.get(`${this.apiUrl}get`, { params });
}


  getView(employeeId?: any, periodId?: any, active?:any,automatic?:any): Observable<any> {
  
    let params = new HttpParams({ fromObject: {
      'employeeId': employeeId,
      'periodId': periodId,
    }});
    if(active){
      params=params.set('active',active)
    }
    if(automatic){
      params=params.set('concept.automatic',automatic)
    }
    return this.http.get(`${this.apiUrl}getView`, { params });
}

  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}update/${id}`, userData);  }
  save(data: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', data);
  }

  delete(id:string){
    return this.http.delete(this.apiUrl+'delete/'+id)
  }

  createFromTemplate(templateId: string, employeeId: string, periodId: string): Observable<any> {
    const body = {
      templateId: templateId,
      employeeId: employeeId,
      periodId: periodId
    };
    return this.http.post(`${this.apiUrl}createFromTemplate`, body);
  }
}

